export const MAIN_SITE = "https://bfb-labs.com";
export const TERMS_AND_CONDITIONS = "https://www.bfb-labs.com/lumi-nova-terms-and-conditions";
export const PRIVACY_POLICY = "https://www.bfb-labs.com/lumi-nova-privacy-policy";
export const INITIAL_SURVEY_REDIRECT = "http://luminova.app/survey-complete";
export const WEEKLY_SURVEY_REDIRECT = "https://luminova.app/weekly-survey-complete";
export const GETTING_STARTED = "https://luminova.app/getting-started";